module.exports = __webpack_public_path__ + "img/romania.ce48887a.svg";